import React, { Fragment, useState } from 'react';

import SubscriptionForm from '@components/SubscriptionForm';
import useEventTracking from '@hooks/useEventTracking';
import useWindowSize from '@hooks/useWindowSize';
import { Page } from '@tracking';
import { WIDTH_SM } from '@utils/constants';
import { LeadTypes } from '@utils/enums';
import { FormLocation } from '@utils/enums';
import { extractQueryParams } from '@utils/queryStringHelper';

import { SubscribeProps } from '.';
import ChoosePlanHeader from './OfferSelection/ChoosePlanHeader';
import CorporateInquiry from './OfferSelection/CorporateInquiry';
import Offer from './OfferSelection/Offer';

const MultipleOffers = ({
  defaultSelectedOffer,
  description,
  offers,
}: Pick<SubscribeProps, 'defaultSelectedOffer' | 'description' | 'offers'>) => {
  const [selectedOffer, setSelectedOffer] = useState(defaultSelectedOffer);
  const { width: windowWidth } = useWindowSize();
  const { Track } = useEventTracking({ page: Page.MultiOffersSubscribe });
  const isMobile = windowWidth < WIDTH_SM;
  const { lead_type } = extractQueryParams(['lead_type']);
  const leadType = Object.values(LeadTypes).includes(lead_type as LeadTypes)
    ? (lead_type as LeadTypes)
    : LeadTypes.SubscribePage;

  return (
    <Track>
      <div className="px-16 sm:px-28" data-testid="subscribe-multiple-offers">
        <div className="mx-auto max-w-full lg:max-w-[1040px]">
          <ChoosePlanHeader description={description} />
          <div className="mb-48 grid grid-cols-1 sm:mb-0 sm:grid-cols-2 sm:gap-28 lg:gap-64">
            <div>
              {offers.map((offer, index) => {
                const isOfferSelected = selectedOffer.code === offer.code;
                return (
                  <Fragment key={`offer-card-${index}`}>
                    <div className="m-auto my-32 max-w-[324px] first:mt-0 xs:max-w-md md:max-w-full">
                      <Offer
                        offer={offer}
                        selectedOfferCode={selectedOffer.code}
                        setSelectedOffer={setSelectedOffer}
                      />
                    </div>
                    {isOfferSelected && isMobile && (
                      <SubscriptionForm
                        buttonText="Subscribe"
                        formLocation={FormLocation.Subscribe}
                        leadType={leadType}
                        presentedOfferCodes={offers.map((offer) => offer.code)}
                        selectedOffer={selectedOffer}
                      />
                    )}
                  </Fragment>
                );
              })}
            </div>
            {!isMobile && (
              <SubscriptionForm
                buttonText="Subscribe"
                formLocation={FormLocation.Subscribe}
                leadType={leadType}
                presentedOfferCodes={offers.map((offer) => offer.code)}
                selectedOffer={selectedOffer}
              />
            )}
          </div>
          <CorporateInquiry />
        </div>
      </div>
    </Track>
  );
};

export default MultipleOffers;
